import PropTypes from 'prop-types'


export default {
  en: PropTypes.string.isRequired,
  es: PropTypes.string,
}
